<template>
    <div class="main-panel">
        <div class="content-wrapper dashboard-shell">
            <div class="cardplay solicitantes-card horizontal-scrollable">
                <div class="row dashboard-header g-3 align-items-center mb-4">
                    <div class="col-lg-7 col-md-8">
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="header-icon"><i class="fa-solid fa-users"></i></span>
                            <h2 class="dashboard-title mb-0">Clientes</h2>
                        </div>
                        <p class="solicitantes-subtitle mb-0">Consulta y administra el listado de clientes registrados.</p>
                    </div>
                    <div class="col-lg-5 col-md-4 text-md-end d-flex justify-content-md-end justify-content-start">
                        <a href="/solicitante/nuevo" class="btn btn-dark dashboard-action-btn">
                            <i class="fa-solid fa-user-plus me-2"></i> Crear nuevo cliente
                        </a>
                    </div>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="summary-chip">
                            <p class="chip-label">Total de clientes</p>
                            <h5 class="chip-value mb-0">{{ this.solicitantes.length }}</h5>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-6">
                        <div class="summary-chip summary-info d-flex align-items-center h-100">
                            <i class="fa-solid fa-circle-info me-2"></i>
                            <span>Utiliza la búsqueda y paginación de la tabla para encontrar clientes rápidamente.</span>
                        </div>
                    </div>
                </div>

                <div class="table-wrapper">
                    <table class="table table-hover align-middle mb-0 solicitantes-table" id="myTable">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre completo</th>
                                <th>DNI</th>
                                <th class="text-center">Acciones</th>
                            </tr>

                        </thead>
                        <tbody v-if="this.ready && this.solicitantes.length > 0">
                            <tr v-for="(solicitante) in this.solicitantes" :key="solicitante.id">
                                <td><span class="id-badge">#{{ solicitante.id }}</span></td>
                                <td class="cliente-nombre">{{ solicitante.nombres }} {{ solicitante.apellidos }}</td>
                                <td><span class="dni-badge">{{ solicitante.dni }}</span></td>
                                <td class="text-center">
                                    <a :href="`/solicitante/${solicitante.id}`" class="btn btn-sm btn-inverse-primary"
                                        v-if="this.Coordinacion || this.Admin || this.Asesor">Ver más</a>
                                    <a class="btn btn-sm btn-inverse-primary" v-else>Mostrar info &nbsp; <i
                                            class="fa-solid fa-person-digging"></i></a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="this.ready && this.solicitantes.length === 0">
                            <tr>
                                <td colspan="4" class="text-center py-4 empty-state">
                                    <i class="fa-regular fa-folder-open me-2"></i>
                                    No hay clientes registrados para mostrar.
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4" class="text-center py-4">
                                    <div class="spinner-border text-warning text-center" role="status">
                                        <span class="visually-hidden text-center" colspan="4" col>Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Security from '../security';
// import { DataTable } from "simple-datatables"
import DataTables from "datatables.net";



export default {
    name: 'Solicitantes-App',
    data() {
        return {
            solicitantes: [],
            ready: false,
            tableInitialized: false,
            datatableLanguage: {
                lengthMenu: "Mostrar _MENU_ registros",
                search: "Buscar:",
                info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                infoEmpty: "Mostrando 0 a 0 de 0 registros",
                infoFiltered: "(filtrado de _MAX_ registros totales)",
                zeroRecords: "No se encontraron resultados",
                emptyTable: "No hay datos disponibles en la tabla",
                paginate: {
                    first: "Primero",
                    previous: "Anterior",
                    next: "Siguiente",
                    last: "Último"
                }
            },

            roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Coordinador Sucursal'],
            Finanzas: false,
            coordinadorSucursal: false,
            Admin: false,
            Coordinacion: false,
            Asesor: false,
            userRoles: []
        }
    },
    updated() {
        if (this.ready && !this.tableInitialized && this.solicitantes.length > 0) {
            this.initializeDataTable()
        }
    },
    beforeMount() {

        // const myTable = document.querySelector("#myTable");
        // const dataTable = new DataTable(myTable);
        // dataTable
        this.fetchData()
        // this.initializeDataTable
    },
    mounted() {
        this.userRoles = Security.getUserRoles();
        this.roles.forEach(element => {
            if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
                this[element] = true;
            } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
                this.coordinadorSucursal = true;
            }
        });
    },
    methods: {
        fetchData() {
            // Realiza la solicitud Fetch para obtener los datos

            const payload = {}
            fetch(process.env.VUE_APP_API_URL + "/admin/solicitantes/all", Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        alert(response.message)
                    } else {
                        // this.books = response.data.books;
                        console.log('Response', response.data.solicitantes)
                        this.solicitantes = response.data.solicitantes
                        this.ready = true;
                        // Llama a la función initializeDataTable() después de un retraso de 2 segundos (2000 milisegundos)
                        // setTimeout(this.initializeDataTable, 20000);
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        },
        initializeDataTable() {
            console.log('Despues Iniciar');
            const myTable = document.querySelector("#myTable");
            if (myTable && !this.tableInitialized) {
                new DataTables(myTable, {
                    language: this.datatableLanguage
                });
                this.tableInitialized = true;
            }
        },
        mostrarSolicitante(id) {
            console.log(id);

        },
    }
}
</script>

<style scoped>
.dashboard-shell {
    background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
    min-height: 100vh;
}

.cardplay {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    background-color: #ffffff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
    background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
    border-radius: 18px;
    color: #fff;
    padding: 16px 18px;
}

.header-icon {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
}

.dashboard-title {
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.solicitantes-subtitle {
    color: #e5e7eb;
    font-size: 0.95rem;
}

.dashboard-action-btn {
    border-radius: 12px;
    padding: 0.62rem 1rem;
    font-weight: 600;
    background: #111827 !important;
    border-color: #111827 !important;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.25);
}

.dashboard-action-btn:hover {
    background: #1f2937 !important;
    border-color: #1f2937 !important;
}

.summary-chip {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 14px;
}

.chip-label {
    margin-bottom: 4px;
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.35px;
}

.chip-value {
    color: #0f172a;
    font-weight: 700;
}

.summary-info {
    color: #334155;
    font-size: 0.92rem;
}

.table-wrapper {
    border: 1px solid #e5eaf0;
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
}

.solicitantes-table thead th {
    background: #f8fafc;
    color: #111827;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 700;
    white-space: nowrap;
}

.solicitantes-table tbody tr {
    border-bottom: 1px solid #f1f5f9;
}

.solicitantes-table tbody tr:hover {
    background: #f8fafc;
}

.id-badge {
    background: #eef2ff;
    color: #3730a3;
    border: 1px solid #c7d2fe;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.82rem;
}

.dni-badge {
    font-family: "Courier New", Courier, monospace;
    font-weight: 700;
    color: #1f2937;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 0.25rem 0.5rem;
    border: 1px solid #e2e8f0;
}

.cliente-nombre {
    font-weight: 600;
    color: #111827;
}

.empty-state {
    color: #64748b;
    font-weight: 500;
}

.horizontal-scrollable {
    overflow-x: auto;
}

:deep(.dataTables_wrapper) {
    padding: 10px 12px 0 12px;
}

:deep(.dataTables_wrapper .dataTables_length),
:deep(.dataTables_wrapper .dataTables_filter) {
    float: none !important;
    width: 100% !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-bottom: 0.75rem;
}

:deep(.dataTables_wrapper .dataTables_length) {
    margin-top: 0.45rem;
}

:deep(.dataTables_wrapper .dataTables_filter label),
:deep(.dataTables_wrapper .dataTables_length label) {
    margin-bottom: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 0.45rem;
    justify-content: center !important;
}

:deep(.dataTables_filter input),
:deep(.dataTables_length select) {
    border: 1px solid #d1d5db !important;
    border-radius: 10px !important;
    padding: 0.35rem 0.6rem !important;
}

:deep(.paginate_button.current) {
    background: #111827 !important;
    border-color: #111827 !important;
    color: #fff !important;
    border-radius: 8px !important;
}

:deep(.dataTables_wrapper .dataTables_info) {
    margin-top: 0.35rem;
}

@media (max-width: 767px) {
    .cardplay {
        padding: 15px;
    }

    .dashboard-action-btn {
        width: 100%;
    }
}
.row > * {

    margin-block: 5px !important;
}
</style>
